export default {
  bind(el, binding, vnode) {
    const handleEsc = (e) => {
      if (e.keyCode === 27) { // ESC键
        // 检查当前元素是否可见
        const dialog = el.querySelector('.el-dialog');
        if (dialog && getComputedStyle(dialog).display !== 'none') {
          // 如果绑定了函数，执行函数
          if (binding.value && typeof binding.value === 'function') {
            binding.value();
          } else {
            // 默认行为：查找并触发关闭按钮点击
            const closeBtn = el.querySelector('.el-dialog__close');
            if (closeBtn) {
              closeBtn.click();
            }
          }
        }
      }
    };

    // 添加键盘事件监听
    document.addEventListener('keydown', handleEsc);
    
    // 保存事件处理函数到元素上，用于后续解绑
    el._escCloseHandler = handleEsc;
  },
  
  unbind(el) {
    // 移除事件监听
    if (el._escCloseHandler) {
      document.removeEventListener('keydown', el._escCloseHandler);
      delete el._escCloseHandler;
    }
  }
};
